export default __webpack_public_path__ + "static/media/humidity.5c27a83f.png";